import { MxContextLanguageDetector, createI18n } from '@soluto-private/mx-i18n';

import { logger } from '@service-initiation/shared-clients-osp-logger';

import { FallbackBackendInit } from './FallbackBackend';

type Options = {
  fallbackTranslationsUrl: string;
  namespace: 'store-initiation' | 'subscriber-scheduling';
};

const onKeyMissing = (
  languages: readonly string[],
  ns: string,
  key: string,
  fallbackValue: string
): void => {
  const err = new Error(
    'i18n Missing key which results in non-readable text displayed'
  );
  logger.error(err, {
    data: { fallbackValue, languages: languages, missingKey: key, ns },
  });
};

export const createI18nClient = ({
  fallbackTranslationsUrl,
  namespace,
}: Options) => {
  const i18nInstance = createI18n();
  const FallbackBackend = FallbackBackendInit(fallbackTranslationsUrl);
  i18nInstance.init({
    init: {
      defaultNS: namespace,
      fallbackLng: false, // use contentful default
      fallbackNS: namespace,
      interpolation: {
        escapeValue: false,
      },
      load: 'currentOnly',
      missingKeyHandler: onKeyMissing,
      ns: namespace,
    },
    plugins: [MxContextLanguageDetector, FallbackBackend],
  });
  return i18nInstance.getClient();
};
